import { render, staticRenderFns } from "./DragForm.vue?vue&type=template&id=5ed2cb89"
import script from "./DragForm.vue?vue&type=script&lang=js"
export * from "./DragForm.vue?vue&type=script&lang=js"
import style0 from "./DragForm.vue?vue&type=style&index=0&id=5ed2cb89&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports